import { useState } from 'react';
import {
  Navbar,
  NavbarBrand,
  Collapse,
  NavbarToggler,
  Nav,
  NavItem,
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import NucampLogo from '../app/assets/img/logo.png';
import UserLoginForm from '../features/user/UserLoginForm';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (

/* Navbar ..................................................................................................... [START] */
    <Navbar dark color='primary' sticky='top' expand='md'>

      <NavbarBrand className='ms-5' href='/'>
        <img src={NucampLogo} alt='nucamp logo' className='float-start' />
        <h1 className='mt-1'>NuCamp</h1>
      </NavbarBrand>

      <NavbarToggler onClick={() => setMenuOpen(!menuOpen)}/>

{/* Collapse ........................................................................................ [START] */}
      <Collapse isOpen={menuOpen} navbar>

        <Nav className='ms-auto' navbar>

{/* "Home" link ................................................................. [START] */}
          <NavItem>
            <NavLink className='nav-link' to='/'>
              <i className='fa fa-home fa-lg' /> Home
            </NavLink>
          </NavItem>
{/* "Home" link ................................................................... [END] */}

{/* "Directory" link ............................................................ [START] */}
          <NavItem>
            <NavLink className='nav-link' to='/directory'>
              <i className='fa fa-list fa-lg' /> Directory
            </NavLink>
          </NavItem>
{/* "Directory" link .............................................................. [END] */}

{/* "About" link ................................................................ [START] */}
          <NavItem>
            <NavLink className='nav-link' to='/about'>
              <i className='fa fa-info fa-lg' /> About
            </NavLink>
          </NavItem>
{/* "About" link .................................................................. [END] */}

{/* "Contact" link .............................................................. [START] */}
          <NavItem>
            <NavLink className='nav-link' to='/contact'>
              <i className='fa fa-address-card fa-lg' /> Contact
            </NavLink>
          </NavItem>
{/* "Contact" link ................................................................ [END] */}

        </Nav>

        <UserLoginForm>
        </UserLoginForm>

      </Collapse>
{/* Collapse .......................................................................................... [END] */}

    </Navbar>
/* Navbar ....................................................................................................... [END] */

  )
};

export default Header;